import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UsersService } from '../../../Services/users.service';
import { CheckAuth } from '../../../Services/utility.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UserModel } from '../../../Models/usersModel';
import { Title } from '@angular/platform-browser';
import { AdminByPassClientLoginService } from 'src/Services/adminByPassClientLogin.service';
import { FilterModel } from 'src/Models/filterModel';
import { ChangePasswordModel } from 'src/Models/ChangePasswordModel';
import { SiteLayoutComponent } from 'src/app/Layout/site-layout/site-layout.component';
import { ActionActivity } from 'src/Models/Common';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ApplicationActivityService } from 'src/Services/application-activity.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  userModel = new UserModel();
  appModel: any;
  tokenKey: string = '';
  loginForm!: FormGroup;
  emailKey: any = '';
  filterModel = new FilterModel();
  userId: number = 0;
  changePasswordModel = new ChangePasswordModel();
  showOldPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  flagWithlink:boolean=true;

  constructor(private readonly appActivity: ApplicationActivityService,
    private readonly adminByPassService: AdminByPassClientLoginService,
    private readonly activedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly checkAuth: CheckAuth,
    private readonly _fb: FormBuilder,
    private readonly toastr: ToastrService,
    private readonly usersService: UsersService,
    private readonly titleService: Title,
    private readonly siteLayoutComponent: SiteLayoutComponent
  ) {
    sessionStorage.removeItem('tokenValue');
    sessionStorage.removeItem('appStartTime');
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
    sessionStorage.removeItem('isAdminOpen');
    sessionStorage.removeItem('AdminUserId');
    sessionStorage.removeItem('StateSetupManageRedirection');
    this.titleService.setTitle('Change Password | JSi360');
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.loginForm = this._fb.group({
      userid: 0,
      oldpassword: [''],
      newpassword: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]]
    })
   
    this.activedRoute.params.subscribe((params: Params) => {
      if (params['id']) {

        if (params['id'] != null) {

          this.emailKey = params['id'];
          if (this.emailKey != '') {
            this.ForgotPasswordDecryptEmailKey(this.emailKey);
          }
          else {
            this.router.navigate(['/Login']);
          }
        }
      }
      else if (sessionStorage.getItem('isLogin') == 'true') {
        this.flagWithlink=false;
        this.userId = +sessionStorage.getItem('UserId');
      }
      else {
        this.router.navigate(['/Login']);
      }
    });
  }

  ForgotPasswordDecryptEmailKey(emailKey: any) {

    this.filterModel.emailKey = emailKey;
    this.adminByPassService.ForgotPasswordDecryptEmailKey('null', this.filterModel).subscribe(
      data => {
        if (data["status"] == "Success") {
          this.flagWithlink=true;
          this.userId = data["userId"];
          this.tokenKey = data['token'];
          sessionStorage.setItem('tokenValue', this.tokenKey);

          if (this.userId > 0) {
            // this.loginForm.setValue({
            //   userid: this.userId,
            //   newpassword: [''],
            //   confirmPassword: ['']
            // });
          }
          else {
            this.showMessage("Email key is invalid. Please contact administrator.", 'Error', 'error');
          }
        }
        else {
          this.showMessage("The link is invalid. Please check your email for a valid link.", 'Error', 'error');
          this.router.navigate(['/login']);
        }
      },
      errorCode => {
        this.showMessage(errorCode, 'Error', 'error');
      }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  updatePassword(loginForm:any) {

    this.changePasswordModel = loginForm.value;    

    this.changePasswordModel.flagWithlink=this.flagWithlink;
    if(!this.flagWithlink){
    if (loginForm.value["oldpassword"] == "") {
      this.showMessage('Please enter old password', 'Error', 'error');
      return;
    }
  }

    if (loginForm.value["newpassword"] == "") {
      this.showMessage('Please enter new password', 'Error', 'error');
      return;
    }
    if (loginForm.value["confirmPassword"] == "") {
      this.showMessage('Please enter confirm password', 'Error', 'error');
      return;
    }

    if (loginForm.value["confirmPassword"] != loginForm.value["newpassword"]) {
      this.showMessage('Confirm password not match', 'Error', 'error');
      return;
    }

    if (loginForm.value["newpassword"].length <= 5) {
      this.showMessage('Password must contain at least 6 character', 'Password To Short', 'error');
      return;
    }
    if (this.isPasswordFormat(loginForm.value["newpassword"]) == null) {
      this.showMessage('password should contain at least 1 uppercase, lowercase, digit and special character', 'Password Pattern', 'error');
      return;
    }

    this.usersService.ChangePassword('null', this.changePasswordModel).subscribe(
      data => {
        if (data['status'] == 'Success') {
          if (data['id'] > 0) {
            this.showMessage('Password changed successfully', 'Success', 'success');

            ApplicationActivityStore('Add', 'Change Password',this.appActivity,0, ActionActivity['Change Password'],'/ChangePassword');
            ApplicationActivityStore('Add', 'Logout',this.appActivity,0, ActionActivity.Logout,'/ChangePassword');
            this.siteLayoutComponent.Logout();
            this.router.navigate(['/login']);
          }
        }
        else{
           this.showMessage('The current password you entered is incorrect.', 'Error', 'error');
        }
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  isPasswordFormat(control: any) {
    let EMAIL_REGEXP = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$/;
    if (control != "" && (control.length > 5 && EMAIL_REGEXP.test(control))) {
      return { "Password pattern are valid": true };
    }

    return null;
  }
}
